// material-ui
import React, { useEffect } from 'react';
import { Button, Grid, MenuItem, Snackbar, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import MainCard from 'ui-component/cards/MainCard';
import Alert from '@mui/material/Alert';
import AnimateButton from 'ui-component/extended/AnimateButton';
import LinearProgress from '@mui/material/LinearProgress';
import axios from 'axios';
import { appblob } from 'services/ApiBlob';
import { getTeam } from 'services/team';

const Report = () => {
    const dispatch = useDispatch();
    const [success, setSuccess] = React.useState('');
    const [error, setError] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [downloadProgress, setDownloadProgress] = React.useState(0);

    // Filtros
    const [status, setStatus] = React.useState('0');
    const [statusFarol, setStatusFarol] = React.useState('Todos');
    const [teamId, setTeamId] = React.useState('Todos');
    const [teams, setTeams] = React.useState([]);

    useEffect(() => {
        const loadTeams = async () => {
            try {
                const response = await getTeam('', '', '');
                setTeams(response.data.data);
            } catch (err) {
                console.error('Erro ao carregar turmas:', err);
            }
        };
        loadTeams();
    }, []);

    const download = async () => {
        try {
            setLoading(true);
            setDownloadProgress(0);

            const params = new URLSearchParams();
            if (status) params.append('status', status);
            if (statusFarol) params.append('status_farol', statusFarol);
            if (teamId) params.append('team_id', teamId);

            const response = await appblob.get(`report?${params.toString()}`, {
                onDownloadProgress: (progressEvent) => {
                    const total = progressEvent.total;
                    if (total) {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / total);
                        setDownloadProgress(percentCompleted);
                    }
                }
            });

            const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'file.xlsx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            setSuccess('Logs gerados com sucesso.');
            setTimeout(() => setSuccess(''), 2000);
        } catch (err) {
            console.error(err);
            setError('Erro ao gerar relatório.');
            setTimeout(() => setError(''), 3000);
        } finally {
            setLoading(false);
            setDownloadProgress(0);
        }
    };

    return (
        <MainCard sx={{ height: '100%' }}>
            <Grid container sx={{ mb: 2 }}>
                <h1
                    style={{
                        font: 'normal normal bold 35px/44px Myriad Pro',
                        color: 'black',
                        padding: 15,
                        marginLeft: '2%'
                    }}
                >
                    Exportação de Relatório
                </h1>
                <hr style={{ width: '95%', marginTop: 0 }} />
            </Grid>

            {error || success ? (
                <Snackbar open={true} autoHideDuration={6000}>
                    <Alert
                        severity={error ? 'error' : 'success'}
                        sx={{ width: '100%', backgroundColor: error ? 'red' : 'green', color: '#FFF' }}
                    >
                        {error || success}
                    </Alert>
                </Snackbar>
            ) : null}

            {loading && (
                <Grid item xs={12} sx={{ mb: 2, px: 2 }}>
                    <LinearProgress />
                </Grid>
            )}

            {/* Filtros */}
            <Grid container spacing={2} sx={{ px: 2, mt: 2 }}>
                <Grid item xs={12} sm={3}>
                    <TextField fullWidth select label="Status" value={status} onChange={(e) => setStatus(e.target.value)}>
                        <MenuItem value="0">Ativo</MenuItem>
                        <MenuItem value="1">Inativo</MenuItem>
                        <MenuItem value="Todos">Todos</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <TextField fullWidth select label="Status Farol" value={statusFarol} onChange={(e) => setStatusFarol(e.target.value)}>
                        <MenuItem value="Cancelados">Cancelados</MenuItem>
                        <MenuItem value="3">Vermelho</MenuItem>
                        <MenuItem value="Todos">Todos</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={3}>
                    <TextField fullWidth select label="Turma" value={teamId} onChange={(e) => setTeamId(e.target.value)}>
                        <MenuItem value="Todos">Todas</MenuItem>
                        {teams.map((team) => (
                            <MenuItem key={team.id} value={team.id}>
                                {team.description}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={6} sm={1} sx={{ mt: 1 }}>
                    <AnimateButton>
                        <Button fullWidth variant="contained" color="primary" onClick={download} disabled={loading}>
                            Baixar
                        </Button>
                    </AnimateButton>
                </Grid>

                <Grid item xs={6} sm={1} sx={{ mt: 1 }}>
                    <AnimateButton>
                        <Button
                            fullWidth
                            variant="contained"
                            color="error"
                            onClick={() => {
                                setStatus('0');
                                setStatusFarol('Todos');
                                setTeamId('Todos');
                                dispatch({ type: 'SET_CLEAR_REPORT_TASK_FILTER' });
                            }}
                            disabled={loading}
                        >
                            Limpar
                        </Button>
                    </AnimateButton>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default Report;
